import type { FaireProductEntity } from "../../entity_types/product";

export const p_m7spxs255g: FaireProductEntity = {
  token: "p_m7spxs255g",
  type: "product",
  name: "Small Double Terminated Points",
  brandToken: "b_at4bwf6pjp",
  brandName: "Keystone Crystals",
  imageUrl:
    "https://cdn.faire.com/fastly/1cf0293bb048ea93706c2673fb4f557251d04a9439813526d10fa6a3e2ff99ce.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/47fd01712352ff5bb3004d52f6455b983c985ac6eee6c69a52ee6718281d5869.png",
    "https://cdn.faire.com/fastly/db1848599776e6b21b58ad699bf3a2750358f81a2fb7c59a98f12f30640c8cd1.png",
    "https://cdn.faire.com/fastly/ecea9a8d99f70cc9e9f5b5c65691c7de8fab822564d3f31c094cfbfe2fb0b94e.png",
    "https://cdn.faire.com/fastly/e8335dd92a11a997d271125b32866f1743b21d18fb442931169e94e99b9ec8a9.png",
    "https://cdn.faire.com/fastly/758405a6a1916855bcca5117ac3f3d451a7aa4e13c5a1407de8231e6abab9489.png",
    "https://cdn.faire.com/fastly/28eb46dd37016e9ccb9acd5edf81715a724efd2f93792100eab74d32c82dcc5b.png",
    "https://cdn.faire.com/fastly/8fe719a9095675c31bf70bc1d4af2c6f2b3f64b6e174b39013d99eba80e280a9.png",
    "https://cdn.faire.com/fastly/92d123a014185e448ce61bbbefeba36324d813de8f91da821a0d4d3d02c3b2c5.png",
    "https://cdn.faire.com/fastly/ed1533c81e26d66692e94f09f53ebf8228aa849f2665c5d03658fb175e699a01.jpeg",
    "https://cdn.faire.com/fastly/3ae40825f8d42a0f59f7edf743682eaadba8f54418ea4b668c3c5aa69fc8a43c.jpeg",
  ],
  priceDollars: 1.39,
  description:
    'Lots of choices of small double terminated points, perfect for making jewelry. These are a great, inexpensive item to stick in a bowl at the front of your store, a perfect add-on item.\n\nThese double terminated points are approximately 7/8" from tip to tip. Size may vary +/- 1/8"\n',
  tags: [],
  msrpDollars: 2.77,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:17.385Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
